import {} from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { FunctionComponent } from 'react';

import './Well.scss';

interface IWellProps {
  className?: string | object;
  theme?: 'primary' | 'danger';
}

const Well: FunctionComponent<IWellProps> = (props) => {
  const { theme, className, children } = props;

  const wellTheme = theme || 'primary';
  const classes = classNames(
    {
      well: true,
      [`well-${wellTheme}`]: true,
    },
    className
  );

  return <div className={classes}>{children}</div>;
};

export default Well;
